










import { defineComponent } from '@vue/composition-api';
import SdsMobileHeader from '@src/app/mobile/navbar/SdsMobileHeader.vue';
import SdsGlobalHeaderLogo from '@modules/layout/header/components/SdsGlobalHeaderLogo.vue';

export default defineComponent({
    components: {
        SdsGlobalHeaderLogo,
        SdsMobileHeader,
    },
});
